import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi';
import { computed } from 'vue';

export const useDisplayCurrencies = () => {
  const { getDisplayCurrencies } = useExperienceApi();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['displayCurrencies'],
    queryFn: async () => {
      const response = await getDisplayCurrencies();

      return response.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    displayCurrencies: computed(() => data.value ?? []),
    isLoading: computed(() => isLoading.value || isFetching.value),
  };
};
